export enum ViewState {
	InitialView = "initial",
	EditView = "edit",
}
